export const COST_FORMAT = "$0,0.00";
export const MODIFIED_AT_TIME_FORMAT = "DD/MM/YYYY HH:mm";
